import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RouteDataService {

    constructor() { }

    private data: any;

    /**
     * Sparar ett värde/objekt för att kunna läsas in en gång. Tar endast primitiva typer, Arrays Objekt med shallow-copy.
     * @param data
     */
    public setSingleReadData(data: any): any {
        this.data = data;
    }

    /**
     * Hämtar ett sparat värde/objekt för att kunna läsas in en gång.
     */
    public getSingleReadData(): any {
        if (!this.data) 
            return null;
        
        if (this.data.constructor === Array) {
            let copy = [...this.data];
            this.data = null;
            return copy;
        }
        if (this.data.constructor === Object)
        {
            let copy = {};
            Object.assign(copy, this.data);
            this.data = null;
            return copy;
        }
        let copy = this.data;
        this.data = null;
        return copy;
    }

}
